import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Spinner() {
    const canvasRef = useRef(null);
    const [isSpinning, setIsSpinning] = useState(false);
    const [angle, setAngle] = useState(0);
    const [winningOffer, setWinningOffer] = useState('');

    const prizes = [
        "Get flat 5% Off",
        "Get flat 10% Off",
        "Get flat ₹150",
        "Get flat ₹200",
        "Get flat ₹300",
        "Better Luck next Time"
    ];

    const colors = [
        "#fcd5ce", "#f9dcc4", "#f8edeb", "#fcd5ce", "#f9dcc4", "#f8edeb"
    ];

    const size = 320;
    const center = size / 2;
    const totalSlices = prizes.length;
    const arcSize = (2 * Math.PI) / totalSlices;

    useEffect(() => {
        const modal = new window.bootstrap.Modal(document.getElementById('exampleModal'));
        modal.show();
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, size, size);

        for (let i = 0; i < totalSlices; i++) {
            const startAngle = angle + i * arcSize;
            const endAngle = startAngle + arcSize;

            ctx.beginPath();
            ctx.moveTo(center, center);
            ctx.arc(center, center, center, startAngle, endAngle);
            ctx.fillStyle = colors[i % colors.length];
            ctx.fill();
            ctx.stroke();

            // Prepare text
            let text = prizes[i];
            let lines = [];

            if (text.length > 15) {
                // Split text at word boundaries near the 15-character limit
                let splitIndex = text.lastIndexOf(" ", 15);
                if (splitIndex === -1) splitIndex = 15; // fallback if no space found
                lines.push(text.slice(0, splitIndex));
                lines.push(text.slice(splitIndex).trim());
            } else {
                lines.push(text);
            }

            // Draw text
            ctx.save();
            ctx.translate(center, center);
            ctx.rotate(startAngle + arcSize / 2);
            ctx.textAlign = "right";
            ctx.fillStyle = "#000";
            ctx.font = "14px sans-serif";

            // Draw one or two lines
            if (lines.length === 1) {
                ctx.fillText(lines[0], center - 20, 5);
            } else {
                ctx.fillText(lines[0], center - 20, -2);
                ctx.fillText(lines[1], center - 20, 14);
            }

            ctx.restore();
        }

    }, [angle]);

    const spinWheel = () => {
        if (isSpinning) return;
        setIsSpinning(true);

        const targetIndex = Math.floor(Math.random() * totalSlices); // random prize
        const anglePerSlice = (2 * Math.PI) / totalSlices;
        const spins = 6;

        // Align targetIndex with the pointer (top center)
        const targetAngle = (totalSlices - targetIndex - 0.5) * anglePerSlice;

        const totalRotation = spins * 2 * Math.PI + targetAngle;
        const duration = 5000;
        const startTime = performance.now();

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const newAngle = totalRotation * easeOut;
            setAngle(newAngle);
            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                setIsSpinning(false);

                // Set the winning prize in state
                setWinningOffer(prizes[targetIndex]);

                // Wait 2 seconds, then show the win modal and hide the spin modal
                setTimeout(() => {
                    const exampleModalEl = document.getElementById('exampleModal');
                    const exampleModal = window.bootstrap.Modal.getInstance(exampleModalEl);
                    if (exampleModal) {
                        exampleModal.hide();
                    }

                    const winModal = new window.bootstrap.Modal(document.getElementById('winModal'));
                    winModal.show();
                }, 2000);
            }


        };

        requestAnimationFrame(animate);


    };

    return (
        <>
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <button
                            type="button"
                            className="btn-close position-absolute"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                        <div className="modal-body">
                            <div className="spin_logo">
                                <img src="/img/logo.png" alt="" className="w-100" />
                            </div>
                            <h5 className="text-center">Spin to win exclusive coupons</h5>
                            <div className="spin-wheel-wrapper mt-5  mb-4" style={{ position: 'relative', width: size, height: size, margin: 'auto' }}>

                                {/* Pointer at the top center */}
                                <div className='pointer-icon-wrapper'>
                                    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M26.4055 23.1703C28.5393 22.5985 29.8288 20.3918 28.9954 18.3459C27.4758 14.6152 25.2606 11.1934 22.4559 8.26856C19.6511 5.34376 16.3251 2.98726 12.6613 1.31276C10.652 0.394464 8.39332 1.59036 7.73272 3.69846L1.08512 24.9111C0.766317 25.9283 1.39332 26.99 2.13112 27.7594C2.86892 28.5288 3.90342 29.1997 4.93312 28.9238L26.4055 23.1703Z" fill="url(#paint0_linear_1713_89)" />
                                        <path d="M26.4055 23.1703C28.5393 22.5985 29.8288 20.3918 28.9954 18.3459C27.4758 14.6152 25.2606 11.1934 22.4559 8.26856C19.6511 5.34376 16.3251 2.98726 12.6613 1.31276C10.652 0.394464 8.39332 1.59036 7.73272 3.69846L1.08512 24.9111C0.766317 25.9283 1.39332 26.99 2.13112 27.7594C2.86892 28.5288 3.90342 29.1997 4.93312 28.9238L26.4055 23.1703Z" stroke="white" strokeWidth="2" />
                                        <defs>
                                            <linearGradient id="paint0_linear_1713_89" x1="21.987" y1="7.78976" x2="-0.640483" y2="30.4172" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#EDCE4D" />
                                                <stop offset="1" stopColor="#EDCE4D" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>

                                {/* Wheel + Button */}
                                <div style={{ position: "relative", width: size, height: size }}>
                                    <canvas
                                        ref={canvasRef}
                                        width={size}
                                        height={size}
                                        style={{ borderRadius: "50%", background: "#d97676" }}
                                    />
                                </div>
                            </div>

                            <div className='d-flex justify-content-center'>
                                <Link to="#"
                                    onClick={spinWheel}
                                    style={{
                                        padding: "10px 20px",
                                        background: "#fff",
                                        border: "2px solid #000",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                    }}
                                >
                                    SPIN
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="winModal" tabIndex="-1" aria-labelledby="winModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content text-center">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body d-flex justify-content-between">
                            <div className="win_modal_left flex-fill d-flex align-items-center justify-content-center">
                                <div className="position-relative">
                                    <svg width="222" height="122" viewBox="0 0 222 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.07273 0H43.391C43.9483 0 44.394 0.453607 44.4571 1.00726C44.9575 5.39606 48.6839 8.80536 53.2066 8.80536C57.7293 8.80536 61.4558 5.39606 61.9561 1.00726C62.0192 0.453607 62.4649 0 63.0222 0H213.927C218.385 0 222 3.61428 222 8.07273V113.018C222 117.476 218.385 121.091 213.927 121.091H62.0512L62.0499 121.09C62.0499 116.226 58.1071 112.283 53.2433 112.283C48.3796 112.283 44.4367 116.226 44.4367 121.09L44.4354 121.091H8.07274C3.61429 121.091 0 117.476 0 113.018V8.07273C0 3.61428 3.61428 0 8.07273 0Z" fill="#F5F5DC" />
                                    </svg>
                                    <div className="position-absolute">
                                        <p className="mb-0">Login & GET</p>
                                        <h5>{winningOffer}</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="sp_login_form border rounded-4 login_none">
                                <h4 className="mb-3">Woah! What a Win</h4>
                                <form action="">
                                    <input type="number" className="form-control mb-2" name="number" placeholder="number" />
                                    <input type="email" className="form-control" name="gmail" placeholder="email" />
                                    <div className="form-check mt-2 mb-0">
                                        <input className="form-check-input" type="checkbox" id="checkDefault" />
                                        <label className="form-check-label w-100 text-start" htmlFor="checkDefault">
                                            Notify me for offers & updates
                                        </label>
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        <Link to="#"
                                            onClick={spinWheel}
                                            style={{
                                                padding: "6px 20px",
                                                background: "#fff",
                                                border: "2px solid #000",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                width: "150px",
                                                margin: "20px 0 0 0 ",
                                            }}
                                        >
                                            SEND OTP
                                        </Link>
                                    </div>
                                </form>
                                <p className="mt-4 mb-0">I accept that I have read & understood Gokwik's <a href="#">Privacy Policy</a> and <a href="#">T&Cs</a>.</p>
                            </div>

                            <div className="sp_login_form border rounded-4 opt_show d-none">
                                <h4 className="mb-3">OTP Verification</h4>
                                <small>Verification code sent to</small>
                                <p><b>+91 8302112324</b> <a href="#">Edit</a></p>
                                <form action="" className="d-flex align-items-center justify-content-between">
                                    <input type="text" className="form-control" name="otp" />
                                    <input type="text" className="form-control" name="otp" />
                                    <input type="text" className="form-control" name="otp" />
                                    <input type="text" className="form-control" name="otp" />
                                </form>
                                <a href="#" className="re_send d-flex align-items-center mt-4 justify-content-center">
                                    <i className="d-icon-clock"></i>
                                    Resend OTP
                                </a>
                                <button className="svelte_jxctds btn btn-primary mt-2 w-100">Verify</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Spinner